import { find, kebabCase } from 'lodash'

function getPlayerRegion (clients = null, idOrSlug = null) {
  return find(clients, client => kebabCase(client.short_name) === idOrSlug).region_id
}

function getPlayerId (clients = null, idOrSlug = null) {
  if (Number.isInteger(parseInt(idOrSlug)) || idOrSlug === 'global-overview') {
    return idOrSlug
  } else {
    return find(clients, client => kebabCase(client.short_name) === idOrSlug).id
  }
}

export {
  getPlayerId,
  getPlayerRegion
}
